<template>
  <el-row class="header" :style="headerStyle">
    <el-col :offset="1" :span="3">
      <el-image style="width: auto; height: 3rem" :src="logo" fit="cover"/>
    </el-col>
    <el-col :offset="5" :span="12" style="margin-top: 0.8rem">
      <el-tabs v-model="activeName" class="puHuiTi-Medium" @tab-click="handleClick">
        <el-tab-pane label="首页" name="index"></el-tab-pane>
        <el-tab-pane label="公司简介" name="companyProfile"></el-tab-pane>
        <el-tab-pane label="产品中心" name="productCenter"></el-tab-pane>
        <el-tab-pane label="工厂展示" name="factoryShow"></el-tab-pane>
        <el-tab-pane label="新闻中心" name="newsCenter"></el-tab-pane>
        <el-tab-pane label="联系我们" name="contactUs"></el-tab-pane>
      </el-tabs>
    </el-col>
    <el-col offset="1" :span="3">
      <div style="display: flex; align-items: center;">
        <div style="margin-left: 0.8rem;color: white; font-weight: bold;">
          <div @click="contactUsJump" id="contact-us"
               style="text-align: left;border: white 1px solid;padding:0.5rem 1rem;margin-top: 1rem;font-size: 0.8rem">
            CONTACT US
          </div>
        </div>
      </div>
    </el-col>
    <el-backtop :bottom="100">
      <el-image :src="backTop" fit="cover"/>
    </el-backtop>
  </el-row>

</template>

<script setup>
import {onMounted, ref, watch} from 'vue'
import {useRouter} from 'vue-router'
import eventBus from '@/utils/eventBus';
import backTop from '@/assets/img/backtop.png'

const activeName = ref('index')
const router = useRouter()
const headerStyle = ref({backgroundColor: 'transparent'});
const handleCustomEvent = (message) => {
  if (message.value !== 0) {
    headerStyle.value = {backgroundColor: 'rgba(0,0,0,0.8)'};
  } else {
    headerStyle.value = {backgroundColor: 'transparent'};
  }
};

const handleClick = (tab) => {
  headerStyle.value = {backgroundColor: 'transparent'};
  router.push({name: tab.props.name})
  const activeBar = document.querySelector('.el-tabs__active-bar');
  if (activeBar) {
    activeBar.style.width = '3rem'; // 修改为所需的宽度
  }
}

function contactUsJump() {
  router.push("contact_us");
  activeName.value = "contactUs"
}

const logo = "https://nb-dx.oss-cn-hangzhou.aliyuncs.com/dist/assets/img/logo.png";
let path = ref(router.currentRoute.value.fullPath);


const handleScroll = () => {
  if (window.scrollY === 0) {
    headerStyle.value = {backgroundColor: 'transparent'};
  } else {
    headerStyle.value = {backgroundColor: 'rgba(0,0,0,0.8)'};

  }

};
const handleWhell = (event) => {
  if (event.deltaY > 0) {
    headerStyle.value = {backgroundColor: 'rgba(0,0,0,0.8)'};
  }
}

onMounted(() => {
  if (path.value === "/") {
    eventBus.on('changePart', handleCustomEvent);
    window.addEventListener("wheel", handleWhell);
    window.removeEventListener("scroll", handleScroll);

  }
  watch(
      () => router.currentRoute.value.fullPath,
      (newPath) => {
        path.value = newPath;
        if (path.value === "/product_center") {
          activeName.value = "productCenter"
        } else if (path.value === "/company_profile") {
          activeName.value = "companyProfile"
        } else if (path.value === "/factory_show") {
          activeName.value = "factoryShow"
        } else if (path.value === "/news") {
          activeName.value = "newsCenter"
        }else if (path.value === "/contact_us") {
          activeName.value = "contactUs"
        } else {
          activeName.value = "index"
        }

        if (path.value === "/") {
          eventBus.on('changePart', handleCustomEvent);
          window.addEventListener("wheel", handleWhell);
          window.removeEventListener("scroll", handleScroll);

        } else {

          window.addEventListener("scroll", handleScroll);
          window.removeEventListener("wheel", handleWhell);

        }
      }
  );


});

</script>

<style>

.header {
  position: fixed;
  width: 100%;
  padding-top: 0.8rem;
  z-index: 1000;
  height: 6rem;
}

.header .el-tabs__item {
  color: #ffffff;
}

/*.header .el-tabs__item:hover {*/
/*  color: var(--el-color-primary);*/
/*}*/

.el-tabs__nav-wrap::after {
  position: static !important;
}


.el-tabs__active-bar {
  background-color: white;

}

.el-tabs__nav {
  height: 3rem;
}

#contact-us:hover {
  color: black;
  background-color: white;
}


</style>
